import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MoreVertIcon from '../../../../../ClientSettings/icons/MoreVertIcon'

const SwellActionMenu = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const menuProps = () => {
    return {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
      getContentAnchorEl: null,
      PaperProps: {
        style: {
          padding: '0',
          borderRadius: '8px',
          minWidth: '190px',
          marginLeft: '8px',
        },
      },
      MenuListProps: {
        style: {
          paddingTop: '0',
          paddingBottom: '0',
        },
      },
    }
  }

  const menuItemStyles = option => {
    return {
      fontSize: 16,
      fontWeight: 400,
      padding: '10px',
      width: '190px',
      height: '38px',
      minHeight: '38px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      textAlign: 'left',
      ...(option ? option.style : {}),
    }
  }
  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
        style={{ margin: '-8px -7px 0 0' }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        {...menuProps()}
      >
        {options.map(option => {
          const onClick = () => {
            option.onClick()
            handleClose()
          }
          return (
            <MenuItem
              key={option.id}
              onClick={onClick}
              style={menuItemStyles(option)}
            >
              {option.name}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}

export default SwellActionMenu
